/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Gamepad_Button_HeaderInputs */



/**
* | output |
* | --- |
* | "Button" |
*
* @param {Options_Pedal_Gamepad_Button_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_gamepad_button_header = /** @type {((inputs?: Options_Pedal_Gamepad_Button_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Gamepad_Button_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Button")
	if (locale === "de") return /** @type {LocalizedString} */ ("Button")
	if (locale === "it") return /** @type {LocalizedString} */ ("Button")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Button")
	if (locale === "es") return /** @type {LocalizedString} */ ("Button")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Button")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Button")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Button")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Button")
	return /** @type {LocalizedString} */ ("Button")
});